module.exports = __webpack_public_path__ + "assets/img/background.8582c710.png";